var render = function render(){var _vm=this,_c=_vm._self._c;return _c('index-page',{attrs:{"parentData":{ grid: _vm.grid, path: _vm.path, grid_key: _vm.grid_key, report_class: _vm.report_class, report_namespace: _vm.report_namespace, transition_key: _vm.transition_key, headerFiltersGroupClass: 'col-4 no-padding' }},on:{"set-loading":_vm.setLoading}})
}
var staticRenderFns = []

export { render, staticRenderFns }